"use strict";

/*******************************************************************************
 *
 *		CONSTANTS / VARIABLES
 *
 ******************************************************************************/
// Get the width (in EMs/REMs) at which the full menu should be shown
let breakpointToDesktopNav;
for (var i = 0; i < document.styleSheets.length; i++) {
	if (document.styleSheets[i].href !== null && document.styleSheets[i].href.indexOf("site.min.css") != -1) {
		var sheetRules = document.styleSheets[i].cssRules;
		for (var j = 0; j < sheetRules.length; j++) {
			if (sheetRules[j].selectorText == "#widthREMs") {
				breakpointToDesktopNav = sheetRules[j].style.width.replace(/[^0-9.]/g, '');
			}
		}
	}
}

// Keep track of whether user is dragging or clicking
let dragging = false;
let swipeDirection, clientX, clientY = "";

// Instantiate lightbox
let lightbox = document.createElement("div");

// Keep track of width in REMs
let htmlStyles = window.getComputedStyle(document.getElementsByTagName("html")[0]);
let widthREMs = window.innerWidth / parseFloat(htmlStyles.fontSize);

// Detect if IE 6-10, IE 11, or Edge
let isIE10 = !!window.ActiveXObject; // IE 6-10
let isIE11 = (document.body.style.msTouchAction !== undefined); // IE 10-11
let isEdge = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style && !window.navigator.msPointerEnabled; // MS Edge);

// Set expiration date for cookies (default to 1 year)
let date = new Date();
date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
let expires = "; expires=" + date.toGMTString();


/*******************************************************************************
 *
 *		FUNCTIONS
 *
 ******************************************************************************/
// IE Polyfills
if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
	Element.prototype.closest = function (s) {
		var el = this;
		if (!document.documentElement.contains(el)) return null;
		do {
			if (el.matches(s)) return el;
			el = el.parentElement || el.parentNode;
		} while (el !== null && el.nodeType === 1);
		return null;
	};
}

(function (arr) {
	arr.forEach(function (item) {
		if (item.hasOwnProperty('remove')) {
			return;
		}
		Object.defineProperty(item, 'remove', {
			configurable: true,
			enumerable: true,
			writable: true,
			value: function remove() {
				if (this.parentNode !== null)
					this.parentNode.removeChild(this);
			}
		});
	});
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (var i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

/**
 *		IS ELEMENT IN VIEWPORT
 *		- Returns "false" only if completely outside of viewport, otherwise...
 *		- "contain" if completely in viewport
 *		- "cover" if completely envelopes the viewport
 *		- "partial" if any portion of the element is within the viewport
 */
function isElementInViewport (el) {
	if (typeof jQuery === "function" && el instanceof jQuery) {
		el = el[0];
	}

	if (!document.body.contains(el)) {
		return false;
	}

	var rect = el.getBoundingClientRect();

	if (rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)) {

		// Element fits completely in viewport
		return "contain";

	} else
	if (rect.top <= 0 &&
		rect.left <= 0 &&
		rect.bottom >= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right >= (window.innerWidth || document.documentElement.clientWidth)) {

		// Viewport fits completely within element
		return "cover";

	} else
	if (rect.top >= (window.innerHeight || document.documentElement.clientHeight) ||
		rect.left >= (window.innerWidth || document.documentElement.clientWidth) ||
		rect.bottom <= 0 ||
		rect.right <= 0 ) {

		// Any side is beyond opposite viewport limit (top side is below bottom, left side is beyond right, bottom is above top, or right is beyond left)
		return false;

	} else {

		// Only remaining option: some portion of element is within viewport, but not all of it
		return "partial";

	}
}

/**
 *		UPDATE BREAKPOINT TO DESKTOP NAV
 *		- Updates the breakpointToDesktopNav variable when the fontSize option is changed
 */
function updateBreakpointToDesktopNav() {
	for (var i = 0; i < document.styleSheets.length; i++) {
		if (document.styleSheets[i].href !== null && document.styleSheets[i].href.indexOf("site.min.css") != -1) {
			var sheetRules = document.styleSheets[i].rules;
			for (var j = 0; j < sheetRules.length; j++) {
				if (sheetRules[j].selectorText == "#widthREMs") {
					var normal = sheetRules[j].style.width.replace(/[^0-9.]/g, '');
				} else if (sheetRules[j].selectorText == 'html[data-font-size="lg"] #widthREMs') {
					var large = sheetRules[j].style.width.replace(/[^0-9.]/g, '');
				} else if (sheetRules[j].selectorText == 'html[data-font-size="xl"] #widthREMs') {
					var xlarge = sheetRules[j].style.width.replace(/[^0-9.]/g, '');
				}
			}
		}
	}
	if (document.documentElement.getAttribute("data-font-size") == "xl") {
		breakpointToDesktopNav = xlarge;
	} else if (document.documentElement.getAttribute("data-font-size") == "lg") {
		breakpointToDesktopNav = large;
	} else if (document.documentElement.getAttribute("data-font-size") == "nm") {
		breakpointToDesktopNav = normal;
	}
}

/**
 *		UPDATE WIDTH REMS
 *		- Updates the widthREMs variable on orientation change or resize (event listeners below)
 *		- Hides any toggle navigation if resizing greater than/equal to breakpointToDesktopNav
 */
function updateWidthREMS() {
	widthREMs = window.innerWidth / parseFloat(htmlStyles.fontSize);

	if (widthREMs >= breakpointToDesktopNav) {
		document.querySelector(".toggle.menu").classList.remove("on");
		var navsWithChildren = document.querySelectorAll(".site-nav .site-menu .has-children");
		for (var i = 0; i < navsWithChildren.length; i++) {
			navsWithChildren[i].classList.remove("on");
			navsWithChildren[i].querySelector(".site-nav .site-menu .has-children > ul").style.display = "none";
		}
	}
}

/**
 *		CLOSE SITEWIDE ALERT
 *		- Close the current site-wide alert when clicking/touching the close button
 *		- Sets/updates a browser cookie with the current alert ID
 */
function closeSitewideAlert(event) {
	if (dragging) return;

	var target = event.target.closest("[data-alert-id]");
	if (target) {
		event.preventDefault();

		// Current value of sitewideAlert cookie?
		var currentIndex = document.cookie.indexOf("sitewideAlert");
		if (currentIndex >= 0) {
			var nextSemiColon = document.cookie.indexOf(";", currentIndex);
			if (nextSemiColon > currentIndex) {
				var sitewideAlertCookie = document.cookie.substr(currentIndex, nextSemiColon - currentIndex);
			} else {
				var sitewideAlertCookie = document.cookie.substr(currentIndex);
			}
			var sitewideAlertValue = sitewideAlertCookie.substr(sitewideAlertCookie.indexOf("=") + 1);
			document.cookie = "sitewideAlert=" + sitewideAlertValue + "|" + target.getAttribute("data-alert-id") + expires + "; path=/";
		} else {
			document.cookie = "sitewideAlert=" + target.getAttribute("data-alert-id") + expires + "; path=/";
		}

		document.getElementById("alert").style.display = "none";
	}
}

/**
 *		LAZY LOAD
 *		- Trigger loading overlay
 *		- Load page via AJAX
 */
function lazyLoad(event) {
	if (dragging) return;

	var target = event.target.closest(".lazy-load");
	if (target) {
		event.preventDefault();

		// Trigger loading overlay
		document.body.classList.add("is-loading");

		// Get parent ID
		var parentID = target.parentNode.getAttribute("id");

		// Load page via AJAX
		var request = new XMLHttpRequest();
		request.onreadystatechange = function () {
			// XHR is done
			if (request.readyState === 4) {
				// XHR is successful
				if (request.status === 200) {
					target.remove();
					document.querySelector("#" + parentID).insertAdjacentHTML("beforeend", request.response.querySelector("#" + parentID).innerHTML);

					// Hide loading overlay
					document.body.classList.remove("is-loading");
				} else {
					// Problem with the XHR, alert and remove loading overlay
					alert("There was an error loading more, please try again.");
					document.body.classList.remove("is-loading");
				}
			}
		};

		// Open the request
		request.open("get", target.querySelector("a").getAttribute("href"), true);
		request.responseType = "document";
		request.send();
	}
}

/**
 *		TOGGLE MENU
 *		- Toggle main navigation on mobile resolutions (lower than breakpointToDesktopNav)
 */
function toggleMenu(event) {
	if (dragging) return;

	var target = event.target.closest(".toggle.menu");
	if (target) {
		event.preventDefault();
		event.stopPropagation();

		target.classList.toggle("on");
		var siteMenu = document.querySelector(".site-nav .site-menu");
		if (window.getComputedStyle(siteMenu).display == "none") {
			siteMenu.style.display = "block";
		} else {
			siteMenu.style.display = "none";
		}
	}
}

/**
 *		TOGGLE CHILD MENUS
 *		- Toggle child navigation on mobile resolutions (lower than breakpointToDesktopNav)
 */
function toggleChildMenu(event) {
	if (dragging) return;

	var target = event.target.closest(".toggle.child");
	if (target) {
		event.preventDefault();
		event.stopPropagation();

		target.parentNode.classList.toggle("on");
		var siblingMenu = target.nextElementSibling;
		if (window.getComputedStyle(siblingMenu).display == "none") {
			siblingMenu.style.display = "block";
		} else {
			siblingMenu.style.display = "none";
		}
	}
}

/**
 *		TOGGLE DESKTOP CHILD MENUS
 *		- Prevent link click on Enter keydown
 *		- Open child menu on first touch or Enter keyup, follow link only if child menu is open
 */
function toggleDesktopChildMenu(event) {
	if (dragging) return;

	if (widthREMs >= breakpointToDesktopNav) {
		var target = event.target.closest(".site-menu ul li.has-children > a");
		if (target && event.type == "keydown" && event.key == "Enter") {
			event.preventDefault();
		} else
		if (target && (event.type == "touchend" || (event.type == "keyup" && event.key == "Enter"))) {
			event.stopPropagation();

			// Prevent default on anchor tag on first touch or Enter key
			if (!target.hasAttribute("data-is-open") || target.getAttribute("data-is-open") == "false") {
				event.preventDefault();

				// Hide other child navs, but not if they're an ancestor
				var menusWithChildren = document.querySelectorAll(".site-menu ul li.has-children");
				for (var i = 0; i < menusWithChildren.length; i++) {
					if (!menusWithChildren[i].contains(target)) {
						menusWithChildren[i].classList.remove("on");
						menusWithChildren[i].querySelector("ul").style.display = "none";
						menusWithChildren[i].querySelector(".site-menu ul li.has-children > a").setAttribute("data-is-open", false);
					}
				}

				// Display child navigation on first touch or Enter key
				target.setAttribute("data-is-open", true);
				target.parentNode.classList.toggle("on");
				target.parentNode.querySelector("ul").style.display = "block";
			} else {
				target.setAttribute("data-is-open", false);
				target.click();
			}
		}
	}
}


/**
 *		TOGGLE ACCESSIBILITY MENU
 *		- Toggle current accessibility option menu, make sure others are hidden
 */
function toggleAccessibilityMenu(event) {
	if (dragging) return;

	var target = event.target.closest(".font-sizes > a, .contrast-modes > a");
	if(target) {
		event.preventDefault();
		event.stopPropagation();

		if (target.parentNode.classList.contains("font-sizes")) {
			document.querySelector(".contrast-modes > ul").style.display = "none";
		} else
		if (target.parentNode.classList.contains("contrast-modes")) {
			document.querySelector(".font-sizes > ul").style.display = "none";
		}
		var siblingMenu = target.nextElementSibling;
		if (window.getComputedStyle(siblingMenu).display == "none") {
			siblingMenu.style.display = "block";
		} else {
			siblingMenu.style.display = "none";
		}
	}
}

/**
 *		UPDATE ACCESSIBILITY OPTION
 *		- Update html or body attribute to chosen font size or contrast mode, respectively
 *		- Set/update browser cookie
 */
function updateAccessibilityOption(event) {
	if (dragging) return;

	var target = event.target.closest("a[data-font-size], a[data-contrast-mode]");
	if (target) {
		// Prevent normal anchor tag behavior (page will reload as a fallback if javascript is disabled)
		event.preventDefault();

		// Update cookies and html/body element data attributes
		if (target.hasAttribute("data-font-size")) {
			var allLinks = document.querySelectorAll("a[data-font-size]:not([data-font-size=" + target.getAttribute("data-font-size") + "])");
			for (var link of allLinks) {
				link.classList.remove("active");
			}
			target.classList.add("active");
			document.documentElement.setAttribute("data-font-size", target.getAttribute("data-font-size"));
			document.cookie = "fontSize=" + target.getAttribute("data-font-size") + expires + "; path=/";

			updateBreakpointToDesktopNav();
		}
		else if (target.hasAttribute("data-contrast-mode")) {
			var allLinks = document.querySelectorAll("a[data-contrast-mode]:not([data-contrast-mode=" + target.getAttribute("data-contrast-mode") + "])");
			for (var link of allLinks) {
				link.classList.remove("active");
			}
			target.classList.add("active");
			document.body.setAttribute("data-contrast-mode", target.getAttribute("data-contrast-mode"));
			document.cookie = "contrastMode=" + target.getAttribute("data-contrast-mode") + expires + "; path=/";
		}

		updateWidthREMS();
		//target.parentNode.parentNode.style.display = "none";
	}
}

/**
 *		CLOSE LIGHTBOX
 *		- Fired on click, touchend, and keyup
  *		- Only applies if lightbox has "is-shown" class AND (escape key is pressed OR (close button is clicked/touched or Enter key is pressed while focused))
 *		- Removes "is-shown" class
 */
function closeLightbox(event) {
	if (dragging) return;

	var target = event.target.closest(".rd-lightbox-close");
	if (lightbox.classList.contains("is-shown") && ((event.key == "Escape" || event.key == "Esc") || (target && (event.type == "click" || event.type == "touchend" || (event.type == "keyup" && event.key == "Enter"))))) {
		event.preventDefault();

		lightbox.querySelector(".content .gallery").innerHTML = "";

		lightbox.classList.remove("is-shown");
		lightbox.removeAttribute("data-active-gallery");
	}
}

/**
 *		OPEN LIGHTBOX
 *		- Add slides and count to lightbox, display
 */
function openLightbox(event) {
	if (dragging) return;

	var target = event.target.closest("[data-lightbox]");
	if (target) {
		event.preventDefault();

		// Which gallery are we displaying?
		var galleryID = target.getAttribute("data-lightbox");
		lightbox.setAttribute("data-active-gallery", galleryID);

		// Add the slides
		lightbox.querySelector(".content .gallery").innerHTML = "";
		var galleryItems = document.querySelectorAll("[data-lightbox=" + galleryID + "]");
		for (var i = 0; i < galleryItems.length; i++) {
			var slide = document.createElement("div");
			slide.setAttribute("data-slide", i + 1);
			// YouTube, Vimeo, or local video link?
			if (galleryItems[i].getAttribute("href").indexOf("youtube") !== -1 || galleryItems[i].getAttribute("href").indexOf("vimeo") !== -1 || galleryItems[i].getAttribute("href").indexOf(".mp4") !== -1 || galleryItems[i].getAttribute("href").indexOf(".m4v") !== -1 || galleryItems[i].getAttribute("href").indexOf(".ogg") !== -1 || galleryItems[i].getAttribute("href").indexOf(".webm") !== -1) {
				galleryItems[i].getAttribute("href").match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

				if (RegExp.$3.indexOf('youtu') > -1) {
					var type = 'youtube';
				} else if (RegExp.$3.indexOf('vimeo') > -1) {
					var type = 'vimeo';
				} else {
					// Get file extension
					var fileExtension = galleryItems[i].getAttribute("href").split(".").pop();
					if (fileExtension == "mp4" || fileExtension == "m4v") {
						var type = 'mp4';
					} else if (fileExtension == "ogg") {
						var type = 'ogg';
					} else if (fileExtension == "webm") {
						var type = 'webm';
					}
				}

				if (type == "youtube") {
					slide.innerHTML = '<div class="embed-container">' +
							'<iframe width="560" height="315" src="https://www.youtube.com/embed/' + RegExp.$6 + '?rel=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>' +
						'</div>';
				} else
				if (type == "vimeo") {
					slide.innerHTML = '<div class="embed-container">' +
							'<iframe src="https://player.vimeo.com/video/' + RegExp.$6 + '" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' +
						'</div>';
				} else {
					slide.innerHTML = '<div class="embed-container">' +
							'<video controls>' +
								'<source src="' + galleryItems[i].getAttribute("href") + '" type="video/' + type + '" /> ' +
							'</video>' +
						'</div>';
				}
			} else
			// Assume an image
			{
				var alt = "";
				if (galleryItems[i].querySelector("img") && galleryItems[i].querySelector("img").hasAttribute("alt")) {
					alt = galleryItems[i].querySelector("img");
				}
				slide.innerHTML = '<img src="' + galleryItems[i].getAttribute("href") + '" alt="' + alt + '" />';
			}

			// Is this the item that triggered the lightbox?
			if (target.getAttribute("href") == galleryItems[i].getAttribute("href")) {
				slide.classList.add("active");
				lightbox.querySelector(".toolbar .pages .current").innerText = i + 1;
			}

			// Add to gallery
			lightbox.querySelector(".content .gallery").appendChild(slide);
		}

		// Set the total count
		lightbox.querySelector(".content").setAttribute("data-count", galleryItems.length);
		lightbox.querySelector(".toolbar .pages .total").innerText = galleryItems.length;

		// Finally, show the lightbox and focus on the close button
		lightbox.classList.add("is-shown");
		lightbox.querySelector(".rd-lightbox-close").focus();
	}
}

/**
 *		PREV SLIDE
 */
function prevSlide() {
	var activeSlide = lightbox.querySelector(".gallery .active");
	activeSlide.classList.remove("active");
	var prevSibling = activeSlide.previousElementSibling;
	if (prevSibling) {
		// If there is a prev slide, make it active
		prevSibling.classList.add("active");
		lightbox.querySelector(".toolbar .pages .current").innerText = prevSibling.getAttribute("data-slide");
	} else {
		// Otherwise, make the last slide active
		var slides = lightbox.querySelectorAll(".gallery > div");
		slides[slides.length - 1].classList.add("active");
		lightbox.querySelector(".toolbar .pages .current").innerText = slides.length;
	}
}
function prevSlideTrigger(event) {
	if (lightbox.classList.contains("is-shown")) {
		// Trigger on arrow left key
		if (event.key == "ArrowLeft" || event.key == "Left") {
			prevSlide();
		}

		// Trigger if swiping right
		var target = event.target.closest(".rd-lightbox .gallery");
		if (target && swipeDirection == "right") {
			prevSlide();
		}

		// Otherwise, return if dragging and trigger if clicking/touching the previous link
		if (dragging) return;
		var target = event.target.closest(".rd-lightbox-prev");
		if (target) {
			event.preventDefault();
			prevSlide();
		}
	}
}

/**
 *		NEXT SLIDE
 */
function nextSlide() {
	var activeSlide = lightbox.querySelector(".gallery .active");
	activeSlide.classList.remove("active");
	var nextSibling = activeSlide.nextElementSibling;
	if (nextSibling) {
		// If there is a next slide, make it active
		nextSibling.classList.add("active");
		lightbox.querySelector(".toolbar .pages .current").innerText = nextSibling.getAttribute("data-slide");
	} else {
		// Otherwise, make the first slide active
		lightbox.querySelector(".gallery > div").classList.add("active");
		lightbox.querySelector(".toolbar .pages .current").innerText = "1";
	}
}
function nextSlideTrigger(event) {
	if (lightbox.classList.contains("is-shown")) {
		// Trigger on arrow right key
		if (event.key == "ArrowRight" || event.key == "Right") {
			nextSlide();
		}

		// Trigger if swiping right
		var target = event.target.closest(".rd-lightbox .gallery");
		if (target && swipeDirection == "left") {
			nextSlide();
		}

		// Otherwise, return if dragging and trigger if clicking/touching the previous link
		if (dragging) return;
		var target = event.target.closest(".rd-lightbox-next");
		if (target) {
			event.preventDefault();
			nextSlide();
		}
	}
}

/**
 *		ADD BACKGROUND TO STICKY NAV ON SCROLL
 */
var siteHeader = document.querySelector(".site-header");
function toggleStickyNavBackground() {
	if (siteHeader.getBoundingClientRect().top <= 0) {
		siteHeader.classList.add("is-sticky");
	} else {
		siteHeader.classList.remove("is-sticky");
	}
}

/**
 *		TOGGLE HEADER SEARCH FORM
 */
function toggleHeaderSearch(event) {
	if (dragging) return;

	var target = event.target.closest(".site-menu .search > a");
	if (target) {
		event.preventDefault();

		if (document.querySelector(".site-search").classList.contains("is-shown")) {
			document.querySelector(".site-search").classList.remove("is-shown")
		} else {
			document.querySelector(".site-search").classList.add("is-shown")
		}
	}
}

/**
 *		CLOSE HEADER SEARCH FORM
 */
function closeHeaderSearch(event) {
	if (dragging) return;

	var target = event.target.closest(".site-search .close");
	if (target) {
		event.preventDefault();

		document.querySelector(".site-search").classList.remove("is-shown")
	}
}

/**
 *		SLAB: GALLERY NAVIGATION
 */
function toggleActiveSlide(event) {
	if (dragging) return;

	var target = event.target.closest(".slab.gallery .nav > a");
	if (target) {
		event.preventDefault();

		var gallery = target.closest(".slab.gallery");
		gallery.querySelector(".slider .slide.active").classList.remove("active");
		gallery.querySelector(".slider .slide[data-slide='" + target.getAttribute("data-slide") + "']").classList.add("active");
	}
}

/**
 *		TEAM BIO MODALS
 */
function triggerBioModal(event) {
	if (dragging) return;

	var target = event.target.closest(".trigger-modal[data-modal]");
	if (target) {
		event.preventDefault();

		document.body.style.overflow = "hidden";
		document.querySelector(".hidden-modals").classList.add("active");
		document.querySelector(".bio-modal[data-modal='" + target.getAttribute("data-modal") + "']").classList.add("active");
	}
}

function closeBioModal(event) {
	if (dragging) return;

	var target = event.target.closest(".bio-modal .close-wrapper a");
	if (target) {
		event.preventDefault();

		document.body.style.overflow = "visible";
		document.querySelector(".hidden-modals").classList.remove("active");
		target.closest(".bio-modal").classList.remove("active");
	}
}

function toggleTimelineEvent(event) {
	if (dragging) return;

	var target = event.target.closest(".timeline .event .top .toggle-detail");
	if (target) {
		event.preventDefault();

		target.parentElement.classList.toggle("active");
		target.parentElement.nextElementSibling.classList.toggle("is-open");
	}
}

/**
 *		TOGGLE ACCORDION
 */
function toggleAccordion(event) {
	if (dragging) return;

	var target = event.target.closest(".accordion a.toggler");
	if (target) {
		event.preventDefault();

		target.classList.toggle("toggled");
		var accordionToggle = target.nextElementSibling;
		if (accordionToggle.style.display == "block") {
			accordionToggle.style.display = "none";
		} else {
			accordionToggle.style.display = "block";
		}
	}
}


/*******************************************************************************
 *
 *		DOMCONTENTLOADED
 *
 ******************************************************************************/
document.addEventListener("DOMContentLoaded", function () {
	/**
	 *		DRAGGING
	 *		- Determine if touch device is moving to prevent unwanted click/touch events
	 */
	document.addEventListener("touchmove", function (event) {
		dragging = true;

		var diffX, diffY = 0;
		diffX = event.touches[0].clientX - clientX;
		diffY = event.touches[0].clientY - clientY;

		if (Math.abs(diffX) > Math.abs(diffY)) {
			if (diffX < 0) {
				swipeDirection = "left";
			} else {
				swipeDirection = "right";
			}
		} else {
			if (diffY < 0) {
				swipeDirection = "up";
			} else {
				swipeDirection = "down";
			}
		}

		clientX = event.touches[0].clientX;
		clientY = event.touches[0].clientY;

	});
	document.addEventListener("touchstart", function (event) {
		dragging = false;
		swipeDirection = "";
		clientX = event.touches[0].clientX;
		clientY = event.touches[0].clientY;
	});

	/**
	 *		UPDATE WIDTHREMS
	 *		- Call updateWidthREMS on orientationchange and resize events
	 */
	window.addEventListener("orientationchange", updateWidthREMS);
	window.addEventListener("resize", updateWidthREMS);

	/**
	 *		OUT OF DATE BROWSERS
	 *		- Displays an "update browser" message in IE 10 and below
	 */
	if (isIE10) {
		var body = document.getElementsByTagName("body")[0];
		var updateBrowser = document.createElement('div');
		updateBrowser.setAttribute("id", "update-browser");
		updateBrowser.innerHTML = '<p>' +
			'<strong>Your browser is out of date!</strong><br>' +
			'This site takes advantage of new web technologies that only modern browsers have access to. Please consider upgrading your browser to <em>improve your web experience here and on sites like Gmail, YouTube, and Facebook</em>. Outdated browsers are also a <em>major source of security flaws</em>.<br>' +
			'<strong>We suggest using <a href="https://www.google.com/chrome" target="_blank">Google Chrome</a>, <a href="https://www.mozilla.org/firefox/" target="_blank">Firefox</a>, or <a href="https://www.microsoft.com/en-us/windows/microsoft-edge" target="_blank">Microsoft Edge</a>.</strong>' +
			'</p>';
		body.insertBefore(updateBrowser, body.children[0]);
	}

	/**
	 *		SITE-WIDE ALERTS
	 *		- Close the visible sitewide alert and update cookie
	 */
	document.addEventListener("click", closeSitewideAlert);
	document.addEventListener("touchend", closeSitewideAlert);

	/**
	 *		LIGHTBOX
	 *		- Add lightbox to DOM
	 *		- Open and close lightbox eventListeners
	 *		- Advance to previous/next slide on click/touch of links or left/right swipe
	 */
	lightbox.classList.add("rd-lightbox");
	lightbox.innerHTML = '<div class="toolbar">' +
			'<div class="pages">' +
				'<span class="current">1</span>' +
				'<span class="sep">/</span>' +
				'<span class="total">5</span>' +
			'</div>' +
			'<div class="links">' +
				'<a href="#" class="rd-lightbox-close" aria-label="Close Lightbox"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"/></svg></a>' +
			'</div>' +
		'</div > ' +
		'<div class="content">' +
			'<a href="#" class="rd-lightbox-prev" aria-label="Previous Slide"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"/></svg></a>' +
			'<div class="gallery"></div>' +
			'<a href="#" class="rd-lightbox-next" aria-label="Next Slide"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"/></svg></a>' +
		'</div > ';
	document.body.appendChild(lightbox);

	// Close lightbox on click, touchend, or Escape key
	document.addEventListener("click", closeLightbox);
	document.addEventListener("touchend", closeLightbox);
	document.addEventListener("keyup", closeLightbox);

	// Open lightbox when clicking a link with a data-lightbox attribute
	document.addEventListener("click", openLightbox);
	document.addEventListener("touchend", openLightbox);

	// Advance to previous slide
	document.addEventListener("click", prevSlideTrigger);
	document.addEventListener("touchend", prevSlideTrigger);
	document.addEventListener("keyup", prevSlideTrigger);

	// Advance to next slide
	document.addEventListener("click", nextSlideTrigger);
	document.addEventListener("touchend", nextSlideTrigger);
	document.addEventListener("keyup", nextSlideTrigger);

	/**
	 *		RD FORMS
	 *		- Disable submit button on page load if using reCAPTCHA
	 *		- Submit via AJAX
	 *		- File inputs: display the name of selected file in the custom overlay
	 */
	// Disable submit button on page load if using reCAPTCHA
	var rdForms = document.querySelectorAll(".rd-form[data-form-id]");
	for (var i = 0; i < rdForms.length; i++) {
		// Disable submit button if reCAPTCHA exists
		if (rdForms[i].querySelector(".g-recaptcha") !== null) {
			rdForms[i].querySelector("#submit" + rdForms[i].getAttribute("data-form-id")).disabled = true;
		}
	}

	// Submit via AJAX
	document.addEventListener("submit", function (event) {
		var target = event.target.closest(".rd-form[data-form-id]");
		if (target) {
			// Prevent normal form submission
			event.preventDefault();

			// Show loading overlay
			document.body.classList.add("is-loading");

			// Get form ID
			var dataFormID = target.getAttribute("data-form-id");

			// Disable submit button and change text
			var submitBtn = target.querySelector("#submit" + dataFormID);
			submitBtn.disabled = true;
			submitBtn.textContent = "working...";

			// Submit via AJAX
			var request = new XMLHttpRequest();
			request.onreadystatechange = function () {
				// XHR is done
				if (request.readyState === 4) {
					// XHR is successful
					if (request.status === 200) {
						// Either there was an error and we have the full form again
						if (request.response.querySelector("#" + target.id)) {
							target.parentNode.replaceChild(request.response.querySelector("#" + target.id), target);

							// If reCAPTCHA is present, re-instantiate and disable submit button
							if (document.querySelector("#" + target.id + " .g-recaptcha") !== null) {
								grecaptcha.render("g-recaptcha-" + dataFormID, {
									"sitekey": document.querySelector("#" + target.id + " .g-recaptcha").getAttribute("data-sitekey"),
									"callback": "enableSubmit" + dataFormID,
									"error-callback": "recaptchaError" + dataFormID,
									"expired-callback": "disableSubmit" + dataFormID
								});
								document.querySelector("#submit" + dataFormID).disabled = true;
							}
						}
						// Or there was no error and we have the success confirmation
						else if (request.response.querySelector("#" + target.id + "-success")) {
							target.parentNode.replaceChild(request.response.querySelector("#" + target.id + "-success"), target);
						}

						// Hide loading overlay
						document.body.classList.remove("is-loading");
					} else {
						// Problem with the XHR, alert the user and closing the loading overlay
						alert("There was an error submitting your information, please try again.");
						document.body.classList.remove("is-loading");
					}
				}
			};

			// Open the request using existing method and action, set responseType, and send
			request.open(target.getAttribute("method"), target.getAttribute("action"), true);
			request.responseType = "document";
			request.send(new FormData(target));
		}
	});

	// File inputs: display the name of selected file in the custom overlay
	document.addEventListener("change", function (event) {
		var target = event.target.closest(".rd-form-file");
		if (target && target.type == "file") {
			var wrapperEl = target.parentNode;
			var overlayEl = wrapperEl.getElementsByClassName("overlay");
			var filenameEl = overlayEl[0].getElementsByClassName("filename");
			filenameEl[0].textContent = target.files[0].name;
		}
	});

	/**
	 *		LAZY LOADING
	 *		- AJAX request for next page of results when triggering a .lazy-load link
	 */
	document.addEventListener("click", lazyLoad);
	document.addEventListener("touchend", lazyLoad);

	/**
	 *		ACCESSIBILITY
	 *		- Toggle font size or contrast mode menus
	 *		- Update font size or contrast mode and update browser cookie to remember setting
	 *		- Toggle accessibility toolbar and update browser cookie to remember setting
	 */
	// Toggle font size or contrast mode menu
	document.addEventListener("click", toggleAccessibilityMenu);
	document.addEventListener("touchend", toggleAccessibilityMenu);

	// Update font size or contrast mode
	document.addEventListener("click", updateAccessibilityOption);
	document.addEventListener("touchend", updateAccessibilityOption);

	// Toggle accessibility toolbar
	document.addEventListener("change", function (event) {
		var target = event.target.closest("[name=accessibilityToolbar]");
		if (target) {
			var accessibilityNav = document.querySelector("nav.accessibility");
			if (target.checked) {
				accessibilityNav.style.display = "block";
				accessibilityNav.classList.add("is-shown");
				document.cookie = "accessibilityToolbar=on" + expires + "; path=/";
			} else {
				accessibilityNav.style.display = "none";
				accessibilityNav.classList.remove("is-shown");
				document.cookie = "accessibilityToolbar=off" + expires + "; path=/";
			}
		}
	});

	/**
	 *		HEADER / NAV
	 *		- Toggle navigation by click/touch on mobile
	 *		- Toggle navigation by mouse enter/leave on desktop
	 */
	// Mobile: Main navigation
	document.addEventListener("click", toggleMenu);
	document.addEventListener("touchend", toggleMenu);

	// Mobile: Child navigation
	document.addEventListener("click", toggleChildMenu);
	document.addEventListener("touchend", toggleChildMenu);

	// Desktop: Close all open child menus on touchend
	document.addEventListener("touchend", function (event) {
		if (widthREMs >= breakpointToDesktopNav) {
			var target = event.target.closest(".site-menu ul li.has-children a");
			// If target is direct child of li.has-children, then follow link
			if (target && !target.parentNode.classList.contains("has-children")) {
			} else
			// Otherwise, stopPropagation and close all menus
			if (!target) {
				event.stopPropagation();

				var linksInMenusWithChildren = document.querySelectorAll(".site-menu ul li.has-children > a");
				for (var i = 0; i < linksInMenusWithChildren.length; i++) {
					linksInMenusWithChildren[i].setAttribute("data-is-open", false);
					linksInMenusWithChildren[i].parentNode.classList.remove("on");
					linksInMenusWithChildren[i].parentNode.querySelector("ul").style.display = "none";
				}
			}
		}
	});

	// Desktop: Open child menu on first touch or Enter keyup, follow link only if child menu is open
	document.addEventListener("touchend", toggleDesktopChildMenu);
	document.addEventListener("keydown", toggleDesktopChildMenu);
	document.addEventListener("keyup", toggleDesktopChildMenu);

	// Desktop: Display child menu when mouse enters, and hide when mouse leaves
	var menusWithChildren = document.querySelectorAll(".site-menu ul li.has-children");
	for (var i = 0; i < menusWithChildren.length; i++) {
		// Show on enter
		menusWithChildren[i].addEventListener("mouseenter", function (event) {
			if (widthREMs >= breakpointToDesktopNav) {
				event.target.classList.add("on");
				event.target.querySelector("ul").style.display = "block";
			}
		});
		// Hide on leave
		menusWithChildren[i].addEventListener("mouseleave", function (event) {
			if (widthREMs >= breakpointToDesktopNav) {
				setTimeout(function () {
					event.target.classList.remove("on");
					event.target.querySelector("ul").style.display = "none";
				}, 500);
			}
		});
	}

	/**
	 *		ADD BACKGROUND TO STICKY NAV ON SCROLL
	 */
	toggleStickyNavBackground();
	document.addEventListener("scroll", function (event) {
		toggleStickyNavBackground();
	});

	/**
	 *		TOGGLE HEADER SEARCH FORM
	 */
	document.addEventListener("click", toggleHeaderSearch);
	document.addEventListener("touchend", toggleHeaderSearch);

	/**
	*		CLOSE HEADER SEARCH FORM
	*/
	document.addEventListener("click", closeHeaderSearch);
	document.addEventListener("touchend", closeHeaderSearch);

	/**
	 *		FEATURED NEWS SLIDER
	 */
	if (document.querySelector(".featured-news-slider .slider") !== null) {
		var featuredNewsSlider = tns({
			container: ".featured-news-slider .slider",
			mode: "carousel",
			items: 1,
			viewportMax: 100,
			controls: false,
			navPosition: "bottom",
			autoplay: true,
			autoplayButtonOutput: false
		});
	}

	/**
	 *		SLAB: GALLERY NAVIGATION
	 */
	document.addEventListener("click", toggleActiveSlide);
	document.addEventListener("touchend", toggleActiveSlide);

	/**
	 *		TEAM BIO MODALS
	 */
	document.addEventListener("click", triggerBioModal);
	document.addEventListener("touchend", triggerBioModal);

	document.addEventListener("click", closeBioModal);
	document.addEventListener("touchend", closeBioModal);

	/**
	 *		TIMELINE
	 */
	document.addEventListener("click", toggleTimelineEvent);
	document.addEventListener("touchend", toggleTimelineEvent);

	/**
	 *		SCROLL ANIMATIONS FOR EVENTS AND CONTENT/MEDIA SLABS
	 */
	var timelineEvents = document.querySelectorAll(".timeline .event");
	timelineEvents.forEach(function(timelineEvent) {
		if (isElementInViewport(timelineEvent)) {
			// Cover, contain, OR partial
			timelineEvent.classList.add("slide-in");
		}else{
			timelineEvent.classList.remove("slide-in");
		}
		document.addEventListener("scroll", function(event){
			if (isElementInViewport(timelineEvent)) {
				// Cover, contain, OR partial
				timelineEvent.classList.add("slide-in");
			}else{
				timelineEvent.classList.remove("slide-in");
			}
		});
	});

	var contentMediaSlabs = document.querySelectorAll(".slab.content-image");
	contentMediaSlabs.forEach(function (contentMediaSlab) {
		if (isElementInViewport(contentMediaSlab)) {
			// Cover, contain, OR partial
			contentMediaSlab.querySelector(".content-image-image").classList.add("slide-in");
		}else{
			contentMediaSlab.querySelector(".content-image-image").classList.remove("slide-in");
		}
		document.addEventListener("scroll", function(event){
			if (isElementInViewport(contentMediaSlab)) {
				// Cover, contain, OR partial
				contentMediaSlab.querySelector(".content-image-image").classList.add("slide-in");
			}else{
				contentMediaSlab.querySelector(".content-image-image").classList.remove("slide-in");
			}
		});
	});

	/**
	 *		TOGGLE ACCORDIONS
	 */
	document.addEventListener("click", toggleAccordion);
	document.addEventListener("touchend", toggleAccordion);

});

/******************************************************************************/